import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "lastUpdatedDays",
  standalone: true,
})
export class LastUpdatedDaysPipe implements PipeTransform {
  transform(lastUpdatedDate: string, prefixText = "Updated ") {
    const currentDate = new Date();
    const lastUpdatedDateObj = new Date(lastUpdatedDate);

    if (isNaN(lastUpdatedDateObj.getTime())) {
      return "N.A.";
    }

    // Set the time to 12:00 AM
    lastUpdatedDateObj.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    const yearDifference =
      currentDate.getFullYear() - lastUpdatedDateObj.getFullYear();
    const monthDifference =
      currentDate.getMonth() - lastUpdatedDateObj.getMonth();
    const dayDifference = currentDate.getDate() - lastUpdatedDateObj.getDate();

    // Adjust months and days for negative values
    let adjustedMonthDifference = monthDifference;
    let adjustedDayDifference = dayDifference;

    if (adjustedDayDifference < 0) {
      adjustedMonthDifference -= 1;
      const previousMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        0
      );
      adjustedDayDifference += previousMonth.getDate();
    }

    let totalMonths = yearDifference * 12 + adjustedMonthDifference;

    if (totalMonths < 0 || (totalMonths === 0 && adjustedDayDifference === 0)) {
      return `${prefixText} Today`;
    }

    if (totalMonths >= 12) {
      const years = Math.floor(totalMonths / 12);
      return `${prefixText}${years} year(s) ago`;
    }

    if (totalMonths > 0) {
      return `${prefixText}${totalMonths} month(s) ago`;
    }

    return `${prefixText}${adjustedDayDifference} day(s) ago`;
  }
}
